import {ParticleConfig} from '@specials/particle-emitter';

export const pointsEmitterConfig = (): ParticleConfig => ({
  alpha: {
    start: 1,
    end: 0,
  },
  speed: {
    start: 300 / 100,
    end: 200 / 100,
  },
  direction: {
    minAngle: -70,
    maxAngle: -110,
  },
  lifeTime: {
    value: 1000,
  },
});
